export default __webpack_public_path__ + "static/media/device-frame-iphone.e2143745.png";